import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=0343c4a9"
import script from "./contractInfo.vue?vue&type=script&lang=js"
export * from "./contractInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0343c4a9')) {
      api.createRecord('0343c4a9', component.options)
    } else {
      api.reload('0343c4a9', component.options)
    }
    module.hot.accept("./contractInfo.vue?vue&type=template&id=0343c4a9", function () {
      api.rerender('0343c4a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/customerManage/contractInfo.vue"
export default component.exports